var Nilfisk = Nilfisk || {};

Nilfisk.mobileMenu = new function() {

    var self = this;

    this.init = function() {
        this.mainMenu();
        this.subMenu();
    }

    //MAIN MENU
    this.mainMenu = function() {
        var winWidth = window.innerWidth;
        //Mobile menu
        if (winWidth < 768) {
            //change location on #js-global-link
            $('#js-global-link-mobile').append($('#js-global-link'));

            //toggle class's to show the menu
            $('.js-menu-toggle').on('click', function() {
                $('.header__nav').toggleClass('mobile-menu-open');
                $('.js-menu-icon-open').toggleClass('icon-hide');
                $('.js-menu-icon-close').toggleClass('icon-show');
                $('body').toggleClass('menu-open');
            });
        }
       
        //Desktop menu
        else {
            //change location on #js-global-link back
            $('#js-global-link-desktop').append($('#js-global-link'));

            $('.js-menu-toggle').unbind('click');
        }
    }

    //SUB MENU
    this.subMenu = function() {
        var winWidth = window.innerWidth;
        var subNavToggleBtn = $('#js-sub-memu-toggle-btn');
        
        if (winWidth <= 768) {
            //Don't show dropdown if there is no sub menu
            if ($('.sidebar__menu-list').children().length < 1) {
                $('#js-sub-memu-toggle-btn').addClass('none-sub-menu');
            }
            else {
                var subNav = $('#js-sub-memu-toggle');

                //Copy link for dropdown
                var newLink = subNavToggleBtn.find('a')
                    .clone()
                    .removeClass('sidebar__menu-header-link')
                    .addClass('sidebar__menu-list--link');

                //Insert link for dropdown
                if(!$('.sidebar-mobile-link').length) {
                    subNav.find('ul').prepend(
                        $('<li>', { 'class': 'sidebar__menu-list--item sidebar-mobile-link' }).html(newLink)
                    );
                }

                //Close dropdown when click on document
                $(document).on('click', function() {
                    subNav.removeClass('show-sub-menu')
                });
                //Stop from closing dropdown when clicking on the dropdown and show dropdown
                subNavToggleBtn.on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    subNav.toggleClass('show-sub-menu');
                });
            }
        }

        else {
            $(document).unbind('click');
            subNavToggleBtn.unbind('click');
            $('.sidebar-mobile-link').remove();
        }
    }
};